var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      class: { loading: _vm.loading },
      attrs: {
        clearable: _vm.clearable,
        disabled: _vm.disabled,
        multiple: _vm.multiple,
        "multiple-limit": _vm.limit,
        filterable: "",
        remote: "",
        placeholder: _vm.placeholder,
        "remote-method": _vm.remoteMethod,
        loading: _vm.loading
      },
      on: { clear: _vm.clear, change: _vm.selectChange },
      model: {
        value: _vm.id,
        callback: function($$v) {
          _vm.id = $$v
        },
        expression: "id"
      }
    },
    _vm._l(_vm.list, function(item) {
      return _c(
        "el-option",
        {
          key: item.id,
          attrs: {
            label: item.realName,
            value: item.id,
            disabled: item.disabled
          }
        },
        [
          _c("span", [_vm._v(_vm._s(item.realName))]),
          _vm._v(" "),
          item.loginName
            ? _c("span", { staticStyle: { color: "#aaa" } }, [
                _vm._v("(" + _vm._s(item.loginName) + ")")
              ])
            : _vm._e()
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a3fa6b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a3fa6b9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserList.vue
// module id = 537
// module chunks = 14